import { render, staticRenderFns } from "./reorganizationPopup.vue?vue&type=template&id=638a12fd&scoped=true"
import script from "./reorganizationPopup.vue?vue&type=script&lang=js"
export * from "./reorganizationPopup.vue?vue&type=script&lang=js"
import style0 from "./reorganizationPopup.vue?vue&type=style&index=0&id=638a12fd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a12fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638a12fd')) {
      api.createRecord('638a12fd', component.options)
    } else {
      api.reload('638a12fd', component.options)
    }
    module.hot.accept("./reorganizationPopup.vue?vue&type=template&id=638a12fd&scoped=true", function () {
      api.rerender('638a12fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/reorganizationPopup.vue"
export default component.exports